function ImageHelper() {
	const images = document.querySelectorAll('.single img');

	if(images) {
		images.forEach(image => {
			image.addEventListener('error', function() {
				image.classList.add('img-error');
			});
		})
	}
}

export default ImageHelper;